// Shopify storefront bridge. Loaded only by the configured theme, never by the demo.
(function () {
  'use strict';
  const config = window.PLACE_WOOD_POSTHOG;
  if (!config || !/^phc_[A-Za-z0-9]+$/.test(config.token || '') || !['us', 'eu'].includes(config.region)) return;
  if (window.PLACE_WOOD_ANALYTICS) return;

  const events = new Set(['map_preview', 'preview_email_captured', 'preview_email_skipped', 'checkout_started']);
  const attribution = new Set(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'gad_source']);
  let client = null, initializing = false, permitted = false, pending = [];
  const tileSelector = '#crop-editor img.leaflet-tile';
  const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  const tiled = new WeakMap();
  let tileSequence = 0;
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  // Includes locale-prefixed Shopify routes. Never record commerce/customer pages.
  function privatePage() { return /\/(cart|checkout|checkouts|account|orders)(\/|$)/i.test(new URL(location.href).pathname); }
  function replayAllowed() { return config.replay === true && !privatePage(); }

  function allowed() {
    try {
      return navigator.globalPrivacyControl !== true && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch { return false; }
  }

  // Mapbox tiles reject the PostHog player's referrer. Keep their loaded pixels in
  // replay-only backgrounds; the live map keeps its original image and behavior.
  function clearMapTile(tile) {
    const entry = tiled.get(tile);
    if (entry) { entry.style.remove(); tile.removeAttribute('data-pw-replay-tile'); tiled.delete(tile); }
  }

  function mapTile(tile) {
    if (!allowed() || !replayAllowed() || !tile?.matches?.(tileSelector) || !tile.parentElement || !tile.complete || !tile.naturalWidth || tiled.get(tile)?.source === tile.currentSrc) return;
    try {
      const canvas = document.createElement('canvas');
      canvas.width = tile.naturalWidth; canvas.height = tile.naturalHeight;
      canvas.getContext('2d').drawImage(tile, 0, 0);
      const image = canvas.toDataURL('image/jpeg', 0.85);
      if (!image.startsWith('data:image/')) return;
      // Separate CSS prevents Leaflet's opacity/position updates from resending
      // the full JPEG in every style mutation (especially costly on mobile).
      clearMapTile(tile);
      const id = String(++tileSequence), style = document.createElement('style');
      tile.setAttribute('data-pw-replay-tile', id);
      style.setAttribute('data-pw-replay-tile', id);
      style.textContent = '#crop-editor img[data-pw-replay-tile="' + id + '"]{background-image:url("' + image + '");background-size:100% 100%}';
      tile.parentElement.append(style);
      tiled.set(tile, {source: tile.currentSrc, style: style});
    } catch {} // A failed pixel read must never interrupt the map or consent.
  }

  // Keep campaign attribution, but omit arbitrary query values and URL fragments.
  function cleanUrl(value) {
    if (typeof value !== 'string' || !value) return value;
    try {
      const url = new URL(value, location.href);
      for (const key of [...url.searchParams.keys()]) if (!attribution.has(key)) url.searchParams.delete(key);
      url.hash = '';
      return url.href;
    } catch { return ''; }
  }

  function beforeSend(event) {
    if (!event || !allowed()) return null;
    if (event.event === '$snapshot' && !replayAllowed()) return null;
    for (const properties of [event.properties, event.properties?.$set, event.properties?.$set_once]) {
      if (!properties) continue;
      for (const key of Object.keys(properties)) {
        if (/url|referrer/i.test(key)) properties[key] = cleanUrl(properties[key]);
      }
    }
    return event;
  }

  function activate() {
    if (!client || !allowed()) return;
    try {
      for (const tile of document.querySelectorAll?.(tileSelector) || []) mapTile(tile);
      client.opt_in_capturing({captureEventName: false});
      client.capture('$pageview', {$current_url: cleanUrl(location.href)});
      if (replayAllowed()) client.startSessionRecording(); else client.stopSessionRecording();
      const queued = pending; pending = [];
      for (const name of queued) if (allowed()) client.capture(name);
    } catch { pending = []; }
  }

  function initialize() {
    if (initializing) return;
    initializing = true;
    // Official PostHog browser bootstrap (https://posthog.com/docs/libraries/js).
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    window.posthog.init(config.token, {
      api_host: 'https://' + config.region + '.i.posthog.com',
      defaults: '2026-05-30',
      person_profiles: 'never',
      autocapture: false,
      capture_dead_clicks: false,
      capture_pageview: false,
      capture_pageleave: true,
      capture_exceptions: false,
      capture_performance: false,
      enable_heatmaps: false,
      enable_recording_console_log: false,
      disable_surveys: true,
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      disable_session_recording: !replayAllowed(),
      session_recording: {
        maskAllInputs: true,
        maskInputFn: function (text, element) {
          return !privatePage() && element?.type !== 'password' && element?.closest?.('#configurator, #preview-dialog, #email-dialog') ? text : '*'.repeat(text.length);
        },
        maskAttributeFn: function (name, value, element) {
          return name === 'src' && element?.matches?.(tileSelector) ? transparentPixel : value;
        },
        maskTextSelector: '.cart-info',
        blockSelector: privatePage() ? 'body' : '.cart-line, .contact-form, .waitlist-form',
        recordHeaders: false,
        recordBody: false,
        recordCrossOriginIframes: false,
        recordCanvas: false
      },
      before_send: beforeSend,
      loaded: function (sdk) {
        client = sdk;
        if (permitted && allowed()) activate();
        else { permitted = false; pending = []; sdk.stopSessionRecording(); sdk.opt_out_capturing(); }
      }
    });
  }

  function sync() {
    const next = allowed();
    if (client && privatePage()) { try { client.stopSessionRecording(); } catch {} }
    if (next === permitted) return;
    permitted = next;
    if (next) {
      if (client) activate(); else initialize();
    } else {
      pending = [];
      if (client) {
        try { client.stopSessionRecording(); client.opt_out_capturing(); } catch {}
      }
    }
  }

  window.PLACE_WOOD_ANALYTICS = {
    mapTile: mapTile,
    clearMapTile: clearMapTile,
    requestHeaders: function () {
      if (!client || !allowed()) return {};
      try { const id = client.get_session_id(); return uuid.test(id) ? {'X-EditionW-Session-ID': id} : {}; } catch { return {}; }
    },
    limited: function (path, response) {
      if (!client || !allowed() || response?.status !== 429) return;
      // No URL queries, inputs, coordinates or arbitrary caller properties.
      const endpoint = path.split('?')[0];
      const name = /^\/api\/(search|selection|generate|lasercut\/(selection|generate))$/.test(endpoint) ? endpoint
        : /^\/api\/(lasercut\/)?jobs\//.test(endpoint) ? endpoint.replace(/(jobs\/).*/, '$1:id')
        : /^\/api\/designs\//.test(endpoint) ? '/api/designs/:id' : '/api/other';
      const requestId = response.headers.get('X-EditionW-Request-ID') || '';
      const reason = response.headers.get('X-EditionW-Limit-Reason') || '';
      const retry = Number(response.headers.get('Retry-After'));
      try { client.capture('map_api_limited', {
        endpoint: name, status: 429,
        request_id: /^[a-f0-9]{32}$/.test(requestId) ? requestId : '',
        limit_reason: /^(quota\.[a-z0-9_]{1,48}|proxy\.(request_rate|concurrent_connections)|application\.(rate_limit|search_pacing))$/.test(reason) ? reason : 'unknown',
        retry_after: Number.isFinite(retry) ? Math.max(0, Math.min(2678400, retry)) : 0
      }); } catch {}
    },
    capture: function (name) {
      if (!events.has(name) || !allowed()) return;
      sync();
      try {
        if (client) client.capture(name);
        else if (pending.length < 30) pending.push(name);
      } catch {}
    }
  };
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) sync(); });
  }
  sync();
})();
